import React, { useContext } from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import {
  Button,
  Text,
  Flex,
  Container,
  Center,
  useToast,
} from '@chakra-ui/react'
import { LockIcon, CheckIcon } from '@chakra-ui/icons'

import FormikInput from 'components/FormikFields/FormikInput'

const schema = Yup.object().shape({
  username: Yup.string().required('Este campo es requerido'),
  password: Yup.string()
    .required('Este campo es requerido')
    .max(30, 'El máximo de caracteres para este campo es 30'),
})

const initialValues = {
  username: '',
  password: '',
}

export interface LoginForm {
  username: string
  password: string
}

const Login: React.FC<{
  login: (credentials: LoginForm) => void
  loading: boolean
}> = ({ login, loading }) => {
  const toast = useToast()

  return (
    <Flex backgroundColor="teal.300" height="100%" alignItems="center">
      <Container
        verticalAlign="middle"
        backgroundColor="white"
        borderRadius="md"
        padding="16px"
        maxWidth={400}
      >
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            try {
              await login(values)
            } catch (err) {
              toast({
                title: 'Error',
                description:
                  'Usuario o contraseña incorrectos. Verificá tus datos y volvé a intentar.',
                duration: 3000,
                isClosable: true,
                status: 'error',
              })
              console.error(err)
            }
          }}
        >
          {({ isSubmitting, isValid }) => {
            return (
              <Form action="" className="box" autoComplete="on">
                <Text marginBottom="3" fontSize="lg" textAlign="center">
                  Repat - Residuos Patógenos
                </Text>
                <FormikInput
                  name="username"
                  label="Usuario"
                  placeholder="Escribí tu usuario"
                  iconLeft={<CheckIcon />}
                />
                <FormikInput
                  name="password"
                  label="Password"
                  placeholder="Escribí tu contraseña"
                  iconLeft={<LockIcon />}
                  type="password"
                />

                <Center marginTop="3">
                  <Button
                    type="submit"
                    disabled={!isValid || isSubmitting}
                    isLoading={isSubmitting}
                  >
                    Iniciar sesión
                  </Button>
                </Center>
              </Form>
            )
          }}
        </Formik>
      </Container>
    </Flex>
  )
}

export default Login
